import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {environment} from 'src/environments/environment';
import {DateTime} from 'luxon';

import {MeterAggregation, meterAggregationsSchema} from './types/device-type.model';
import {
    ConsumptionReportDetails,
    consumptionReportDetailsSchema,
} from './types/consumption-report.model';
import {AttachmentsUtil} from '@shared/utils/attachments-utils';

@Injectable({
    providedIn: 'root',
})
export class ConsumptionReportService {
    private baseUrl = environment.onlineServiceUrl;
    constructor(
        private http: HttpClient,
        private attachmentsUtil: AttachmentsUtil,
    ) {}

    getMeterAggregations(buildingNo: string | null): Observable<MeterAggregation[]> {
        if (buildingNo === null) {
            return new Observable<MeterAggregation[]>(observer => {
                observer.error({message: 'Building number is null'});
            });
        }
        const url = `${this.baseUrl}/buildings/${buildingNo}/meteraggregations`;
        return this.http
            .get(url, {withCredentials: true})
            .pipe(map(data => meterAggregationsSchema.parse(data)));
    }

    getConsumptionReports(
        buildingNo: string,
        startDate: DateTime,
        endDate: DateTime,
        deviceTypes: {
            allocationUnit: string;
            meterType: number | null;
            unit: number | null;
        }[],
        groupLevel: string,
        periodInterval: string,
    ): Observable<ConsumptionReportDetails[]> {
        const url = `${this.baseUrl}/buildings/${buildingNo}/consumptionreport`;
        const body = {
            startDate: startDate.toString(),
            endDate: endDate.toString(),
            deviceTypes: deviceTypes,
            groupLevel: groupLevel,
            periodInterval: periodInterval,
            export: null,
        };

        return this.http
            .post<ConsumptionReportDetails[]>(url, body, {withCredentials: true})
            .pipe(map(data => data.map(cr => consumptionReportDetailsSchema.parse(cr))));
    }

    downloadFile(
        buildingNo: string,
        startDate: DateTime,
        endDate: DateTime,
        deviceTypes: {
            allocationUnit: string;
            meterType: number | null;
            unit: number | null;
        }[],
        groupLevel: string,
        periodInterval: string,
    ): void {
        const url = `${this.baseUrl}/buildings/${buildingNo}/consumptionreport`;
        const body = {
            startDate: startDate.toString(),
            endDate: endDate.toString(),
            deviceTypes: deviceTypes,
            groupLevel: groupLevel,
            periodInterval: periodInterval,
            export: 'excel',
        };

        this.http
            .post(url, body, {
                withCredentials: true,
                observe: 'response',
                responseType: 'blob',
            })
            .subscribe(response => {
                this.attachmentsUtil.downloadBlob(
                    response,
                    `consumption-report_${startDate.toLocaleString()}-${endDate.toLocaleString()}`,
                    'excel',
                );
            });
    }
}
